module.exports = __webpack_public_path__ + "img/zhu_xc1.c9184d2a.jpg";